export const SOURCE = 'source';
export const VAR_DETAILS = 'vardetails';
export const TEACHING_TAG = 'teaching_tag';
export const DOWNLOAD = 'download';
export const IMPORT = 'Import';
export const N = 'n';
export const PEDAGOGICAL_NOTES = 'Pedagogical Notes';

export const hiddenColumns = [SOURCE, VAR_DETAILS, TEACHING_TAG, DOWNLOAD];

export const order = ['name', 'variables', 'samplesize', 'description', 'pednotes', 'download'];
